import { authorizedInstance } from "../config/axios"
import { buildQueryString } from "../utils"

// The endpoint's wire param is `perPage`, but every other hook/component in
// this app speaks `page`/`limit` via usePagination() — translate once here
// rather than renaming the shared hook convention.
export const getCustomerSuccessDeals = async ({
  page,
  limit,
  filters = {},
}) => {
  const query = buildQueryString({
    page,
    perPage: limit,
    patientIssuerName: filters.patientIssuerName,
    accessionNo: filters.accessionNo,
    trackingDealStatus: filters.trackingDealStatus,
    customerSatisfactionStatus: filters.customerSatisfactionStatus,
    startDate: filters.startDate,
    endDate: filters.endDate,
  })

  const response = await authorizedInstance.get(
    `/customer-success-deals?${query}`
  )

  return response.data
}

export const getCustomerSuccessDealStats = async ({ filters = {} } = {}) => {
  const query = buildQueryString({
    patientIssuerName: filters.patientIssuerName,
    accessionNo: filters.accessionNo,
    startDate: filters.startDate,
    endDate: filters.endDate,
  })

  const response = await authorizedInstance.get(
    `/customer-success-deals/stats?${query}`
  )

  return response.data // { total, trackingStatusCounts, customerSatisfactionStatusCounts, centers }
}

export const getCustomerSuccessCenters = async ({
  page,
  limit,
  filters = {},
}) => {
  const query = buildQueryString({
    page,
    perPage: limit,
    centerName: filters.centerName,
    status: filters.status,
  })

  const response = await authorizedInstance.get(
    `/customer-success-deals/centers?${query}`
  )

  return response.data // { data, total, page, perPage } — data[].Cases[] nested
}
